export const EASY = [
    {
        rowValue: 3,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 3,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 3,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 3,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 2,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 2,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 2,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 2,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 1,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 1,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 1,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 1,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 0,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 0,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 0,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 0,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
];

export const MEDIUM = [
    {
        rowValue: 5,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 5,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 5,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 5,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 5,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 5,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 4,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 4,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 4,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 4,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 4,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 4,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 3,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 3,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 3,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 3,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 3,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 3,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 2,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 2,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 2,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 2,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 2,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 2,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 1,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 1,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 1,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 1,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 1,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 1,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 0,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 0,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 0,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 0,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 0,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    }, {
        rowValue: 0,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
];


export const HARD = [
    {
        rowValue: 7,
        colValue: 7,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 7,
        colValue: 6,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 7,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 7,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 7,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 7,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 7,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 7,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 6,
        colValue: 7,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 6,
        colValue: 6,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 6,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 6,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 6,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 6,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 6,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 6,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 5,
        colValue: 7,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 5,
        colValue: 6,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 5,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 5,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 5,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 5,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 5,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 5,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 4,
        colValue: 7,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 4,
        colValue: 6,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 4,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 4,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 4,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 4,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 4,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 4,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 3,
        colValue: 7,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 3,
        colValue: 6,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 3,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 3,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 3,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 3,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 3,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 3,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 2,
        colValue: 7,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 2,
        colValue: 6,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 2,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 2,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 2,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 2,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 2,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 2,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 1,
        colValue: 7,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 1,
        colValue: 6,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 1,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 1,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 1,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 1,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 1,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 1,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 0,
        colValue: 7,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 0,
        colValue: 6,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 0,
        colValue: 5,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 0,
        colValue: 4,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 0,
        colValue: 3,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 0,
        colValue: 2,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 0,
        colValue: 1,
        isActive: 0,
        binaryValue: 0
    },
    {
        rowValue: 0,
        colValue: 0,
        isActive: 0,
        binaryValue: 0
    },
];
